import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "table-editor" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "tab-query"
}
const _hoisted_5 = { class: "query-group" }
const _hoisted_6 = { class: "query-form" }
const _hoisted_7 = { class: "query-filter" }
const _hoisted_8 = { class: "filter-form" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "query-filter" }
const _hoisted_11 = { class: "filter-form" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "filter-form" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "filter-form" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 0,
  class: "filter-form"
}
const _hoisted_21 = { class: "filter-actions" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "query-filter" }
const _hoisted_25 = { class: "filter-list" }
const _hoisted_26 = { class: "filter-spans" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 1,
  class: "tab-cols"
}
const _hoisted_31 = { class: "col" }
const _hoisted_32 = { class: "col-controls" }
const _hoisted_33 = ["disabled", "onClick"]
const _hoisted_34 = ["disabled", "onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 0,
  class: "col-query"
}
const _hoisted_37 = { class: "query-content" }
const _hoisted_38 = { class: "col-group" }
const _hoisted_39 = ["onUpdate:modelValue", "onChange"]
const _hoisted_40 = ["value"]
const _hoisted_41 = {
  key: 0,
  class: "col-group"
}
const _hoisted_42 = ["onUpdate:modelValue", "onChange"]
const _hoisted_43 = ["value"]
const _hoisted_44 = {
  key: 1,
  class: "col-group"
}
const _hoisted_45 = ["onUpdate:modelValue", "onInput"]
const _hoisted_46 = { class: "col-content" }
const _hoisted_47 = { class: "col-group" }
const _hoisted_48 = ["onUpdate:modelValue"]
const _hoisted_49 = { class: "actions" }
const _hoisted_50 = {
  key: 2,
  class: "tab-content"
}
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = { class: "form-group" }
const _hoisted_54 = { class: "switchs" }
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = { class: "color-group" }

import { computed, onMounted, ref, watch } from "vue";
import { ColorPicker } from "vue3-colorpicker";
import draggable from "vuedraggable";
import cloneDeep from "lodash-es/cloneDeep";
import get from "lodash-es/get";
import "vue3-colorpicker/style.css";
// types
import type {
  ReportType,
  ReportBlockType,
  FilterType,
} from "@/common/types/report";
// utils
import { bsonId } from "@/common/utils/common";
import { sanitizeText } from "@/common/utils/text";
import { getDateAndHour, getDiffBreaks, getDate } from "@/common/utils/dates";
// components
import { baseSelect, baseSwitch, svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'table-editor',
  props: {
    block: {},
    report: {},
    zoom: {}
  },
  emits: ["block:update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const DEFAULT_STYLE = {
  background: "#ffffff",
  color: "#000000",
  "font-size": "16px",
  "font-style": "normal",
  "font-family": "Calibri",
  "font-weight": "normal",
  "line-height": "1.5",
  "text-align": "left",
  "text-decoration": "none",
};

const internalBlock = ref(cloneDeep(props.block));
const internalStyle = ref({ ...DEFAULT_STYLE });
const selectedTab = ref<string>("query");
const columns = ref<any[]>([]);

const filter = ref<FilterType>({
  custom: null,
  field: null,
  table: null,
  value: null,
});

const filterOptions = ref<{ label: string; value: any }[]>([]);

const isCustom = computed(
  () =>
    filter.value.value?.includes("custom") ||
    filter.value.field?.includes("custom"),
);

function parseMetadata(raw: any): any {
  if (raw === null || raw === undefined) return null;
  if (typeof raw === "object") return raw;
  if (typeof raw !== "string") return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function toArray(value: any): any[] {
  if (value === null || value === undefined) return [];
  return Array.isArray(value) ? value : [value];
}

function looseEqual(a: any, b: any): boolean {
  return (
    String(a ?? "")
      .trim()
      .toLowerCase() ===
    String(b ?? "")
      .trim()
      .toLowerCase()
  );
}

function isEmptyValue(value: any): boolean {
  return (
    value === null || value === undefined || value === "" || value === "custom"
  );
}

/**
 * Resolve o valor de uma célula, tratando imagens.
 * - Se NÃO for imagem: devolve o valor em string (com suporte a array).
 * - Se for imagem: devolve uma data URL pronta a partir de:
 *     • string já em `data:...`
 *     • objeto `{ file, mime_type }`  (equipamentos, foto de formulário)
 *     • objeto `{ base64 }`           (empresa)
 */
function resolveCellValue(raw: any, isImage: boolean): string {
  if (!isImage) {
    if (raw === null || raw === undefined) return "";
    if (Array.isArray(raw)) {
      return raw
        .map((r) => resolveCellValue(r, false))
        .filter((v) => v !== "")
        .join(", ");
    }
    return String(raw);
  }

  if (!raw) return "";

  if (typeof raw === "string") {
    return raw.startsWith("data:") ? raw : "";
  }

  if (raw.file) {
    return `data:${raw.mime_type ?? "image/png"};base64,${raw.file}`;
  }

  if (raw.base64) return raw.base64;

  return "";
}

const formatAnalyse = (analyse: any) => {
  if (!analyse) {
    return {
      code: "",
      danger: 0,
      description: "",
      start_edited_motive: "",
      end_edited_motive: "",
      canceled_description: "",
      status: "",
      time: null,
      start_date: "",
      end_date: "",
      canceled_date: "",
    };
  }

  return {
    code: analyse.code,
    danger: analyse.danger,
    description: analyse.description,
    start_edited_motive: analyse.start_edited_motive,
    end_edited_motive: analyse.end_edited_motive,
    canceled_description: analyse.canceled_description,
    status: titles.value[analyse.status?.toLowerCase() as never] ?? "",
    time: !analyse.start_date
      ? null
      : getDiffBreaks(
          analyse.start_date,
          analyse.end_date,
          analyse.breaks || [],
        ).text,
    start_date: getDateAndHour(analyse.start_date),
    end_date: getDateAndHour(analyse.end_date),
    canceled_date: getDateAndHour(analyse.canceled_date),
  };
};

const formatEquipment = (equipment: any) => {
  return {
    ...equipment,
    // ⚠️ NÃO sobrescrever `avatar` — ele já vem com { file, mime_type } do backend.
    calibration_date: getDate(equipment.calibration_date),
    expired_date: getDate(equipment.expired_date),
    fabrication_date: getDate(equipment.fabrication_date),
    next_calibration: getDate(equipment.next_calibration),
  };
};

const titles = computed(() => ({
  analyse: "Análise",
  canceled: "Cancelado",
  canceled_date: "Data de Cancelamento",
  canceled_description: "Motivo de Cancelamento",
  code: "Código",
  concluded: "Concluído",
  custom: "Personalizado",
  data: "Dados",
  danger: "Grau de Risco",
  description: "Descrição",
  end_date: "Término",
  end_edited_motive: "Término Editado Motivo",
  name: "Nome",
  full_document: "Documento",
  ges_description: "GES Descrição",
  ges_name: "GES Nome",
  ges_status: "GES Status",
  registration_number: "Matricula",
  role: "Cargo",
  sample: "Amostra",
  sector: "Setor",
  social_name: "Nome Social",
  paused: "Pausado",
  pending: "Pendente",
  result: "Resultado",
  started: "Iniciado",
  status: "Status",
  start_date: "Início",
  start_edited_motive: "Início Editado Motivo",
  method: "Método",
}));

const evaluationData = computed(() => {
  if (!props.report?.evaluation) {
    return null;
  }

  return {
    ...props.report?.evaluation,
    start_date: getDateAndHour(props.report?.evaluation?.start_date),
    end_date: getDateAndHour(props.report?.evaluation?.end_date),
    period_start_date: getDateAndHour(
      props.report?.evaluation?.period_start_date,
    ),
    period_end_date: getDateAndHour(props.report?.evaluation?.period_end_date),
  };
});

/**
 * Agrega equipamentos do root E das análises.
 * O payload real tem `report.equipments = []` no topo, mas cada
 * análise carrega seus próprios `analysis.equipments`.
 */
const equipmentData = computed(() => {
  const direct = props.report?.equipments ?? [];

  const fromAnalysis = (props.report?.analysis ?? []).flatMap(
    (a: any) => a?.equipments ?? [],
  );

  // Deduplica por equipment_id (o mesmo equipamento pode aparecer
  // em várias análises)
  const map = new Map<string, any>();

  [...direct, ...fromAnalysis].forEach((eq: any) => {
    if (eq?.equipment_id) {
      map.set(eq.equipment_id, eq);
    }
  });

  return Array.from(map.values()).map((eq) => formatEquipment(eq));
});

const analysisData = computed(() =>
  (props.report?.analysis ?? []).map((analyse: any) => ({
    data: formatAnalyse(analyse),
    evaluation: evaluationData.value,
    employee: analyse?.employee ?? null,
    equipment: analyse?.equipments ?? [],
    // ⬇️ CORREÇÃO: chave "results" (plural) para bater com `resultMap.field`
    results: analyse?.results ?? [],
  })),
);

const dataMap = computed(() => ({
  analysis: analysisData.value,

  // Agora `equipment` não está mais vazio
  equipment: equipmentData.value.map((equipment: any) => ({
    data: equipment,
  })),

  evaluation: {
    data: evaluationData.value,
  },

  methods: (props.report?.analysis ?? [])
    .flatMap((analyse: any) => analyse?.methods ?? [])
    .map((method: any) => {
      const analyse = (props.report?.analysis ?? []).find(
        (a: any) => a.analysis_id === method.analysis_id,
      );

      const custom = method?.metadata ?? [];

      return {
        analyse,
        custom,
        data: method,
        employee: analyse?.employee ?? null,
        evaluation: props.report?.evaluation,
        sample: analyse?.samples ?? [],
        form: analyse?.forms ?? [],
      };
    }),

  results: (props.report?.analysis ?? [])
    .flatMap((analyse: any) => analyse?.results ?? [])
    .map((result: any) => {
      const analyse = (props.report?.analysis ?? []).find(
        (a: any) => a.analysis_id === (result.analysis_id ?? result.owner_id),
      );

      if (!analyse) return null;

      const methods = (analyse.methods ?? []).find(
        (m: any) => m.method_id === result.method_id,
      );

      const samples = (analyse.samples ?? []).find(
        (s: any) => s.sample_id === result.sample_id,
      );

      const resultMeta = parseMetadata(result.metadata) ?? {};

      const customResult = [
        ...(resultMeta.fields_ai ?? []),
        ...(resultMeta.fields ?? []),
      ].map((field: any) => ({
        id: field.id,
        label: field.name,
        value: field.answer,
      }));

      const answersMeta = parseMetadata(analyse.answers?.metadata) ?? {};

      const answer = {
        ...(answersMeta.form ?? {}),
        ...(answersMeta.method ?? {}),
      };

      const customAnswer: any[] = [];
      Object.entries(answer).forEach(([key, value]) => {
        const form = (analyse.forms ?? []).find((f: any) => f.form_id === key);
        const method = (analyse.methods ?? []).find(
          (m: any) => m.method_id === key,
        );

        Object.entries(value as any).forEach(([questionKey, questionValue]) => {
          const question =
            form?.questions?.find((q: any) => q.question_id === questionKey) ??
            method?.questions?.find((f: any) => f.question_id === questionKey);

          if (question) {
            customAnswer.push({
              id: question.question_id,
              label: question.name,
              value: questionValue,
            });
          }
        });
      });

      return {
        data: result,
        analyse: formatAnalyse(analyse),
        employee: analyse?.employee ?? null,
        equipment: analyse?.equipments ?? [],
        evaluation: props.report?.evaluation,
        form: analyse?.forms ?? [],
        method: methods,
        sample: samples,
        custom_result: customResult,
        custom_answer: customAnswer,
      };
    })
    .filter(Boolean),

  employee: (props.report?.analysis ?? []).map((analyse: any) => ({
    data: analyse?.employee ?? null,
    analyse: formatAnalyse(analyse),
  })),
}));

const analyseMap = computed(() => ({
  field: "analyse",
  label: "Análise",
  list: [
    { field: "code", label: "Código" },
    { field: "danger", label: "Grau de Risco" },
    { field: "description", label: "Descrição" },
    { field: "status", label: "Status" },
    { field: "start_date", label: "Início" },
    { field: "start_edited_motive", label: "Início Editado Motivo" },
    { field: "end_date", label: "Término" },
    { field: "end_edited_motive", label: "Término Editado Motivo" },
    { field: "time", label: "Tempo" },
    { field: "canceled_date", label: "Data de Cancelamento" },
    { field: "canceled_description", label: "Motivo de Cancelamento" },
  ],
}));

const answerMap = computed(() => ({
  field: "answer",
  label: "Perguntas",
  list: [{ field: "custom_answer", label: "Personalizado" }],
}));

const equipmentMap = computed(() => ({
  field: "equipments",
  label: "Equipamentos",
  list: [
    { field: "avatar", label: "Foto", is_image: true },
    { field: "name", label: "Nome" },
    { field: "code", label: "Código" },
    { field: "brand", label: "Marca" },
    { field: "model", label: "Modelo" },
    { field: "calibration_date", label: "Data de Calibração" },
    { field: "expired_date", label: "Data de Expiração" },
    { field: "fabrication_date", label: "Data de Fabricação" },
    { field: "next_calibration", label: "Próxima Calibração" },
    { field: "serial_number", label: "Número de Série" },
    { field: "description", label: "Descrição" },
  ],
}));

const evaluationMap = computed(() => ({
  field: "evaluation",
  label: "Avaliação",
  isFind: false,
  list: [
    { field: "custom", label: "Personalizado..." },
    { field: "code", label: "Código" },
    { field: "description", label: "Descrição" },
    { field: "status", label: "Status" },
    { field: "start_date", label: "Início" },
    { field: "period_start_date", label: "Previsão de Início" },
    { field: "period_end_date", label: "Previsão de Término" },
    { field: "end_date", label: "Término" },
    { field: "progress", label: "Progresso" },
    { field: "time", label: "Tempo" },
  ],
}));

const employeeMap = computed(() => ({
  field: "employee",
  label: "Funcionário",
  list: [
    { field: "name", label: "Nome" },
    { field: "full_document", label: "Documento" },
    { field: "ges_description", label: "GES Descrição" },
    { field: "ges_name", label: "GES Nome" },
    { field: "ges_status", label: "GES Status" },
    { field: "registration_number", label: "Matricula" },
    { field: "role", label: "Cargo" },
    { field: "sector", label: "Setor" },
    { field: "social_name", label: "Nome Social" },
    { field: "status", label: "Status" },
  ],
}));

const methodGroupMap = computed(() => ({
  field: "method_group",
  label: "Grupo de Métodos",
  list: [
    { field: "name", label: "Nome" },
    { field: "code", label: "Código" },
    { field: "custom", label: "Personalizado" },
  ],
}));

const methodMap = computed(() => ({
  field: "method",
  label: "Método",
  list: [
    { field: "name", label: "Nome" },
    { field: "code", label: "Código" },
    { field: "custom", label: "Personalizado" },
  ],
}));

const formMap = computed(() => ({
  field: "forms",
  label: "Formulários",
  list: [
    { field: "name", label: "Nome" },
    { field: "code", label: "Código" },
    { field: "custom", label: "Personalizado" },
  ],
}));

const resultMap = computed(() => ({
  field: "results",
  label: "Resultado",
  list: [
    { field: "custom_result", label: "Personalizado..." },
    { field: "name", label: "Nome" },
    { field: "result", label: "Resultado" },
    { field: "description", label: "Descrição" },
  ],
}));

const sampleMap = computed(() => ({
  field: "sample",
  label: "Amostras",
  list: [
    { field: "name", label: "Nome" },
    { field: "code", label: "Código" },
    { field: "custom", label: "Personalizado" },
  ],
}));

const signatureMap = computed(() => ({
  field: "signatures",
  label: "Assinaturas",
  list: [
    { field: "name", label: "Nome" },
    { field: "code", label: "Código" },
    { field: "custom", label: "Personalizado" },
  ],
}));

const tableMap = computed(() => [
  {
    table: "analysis",
    label: "Análises",
    list: [
      { ...analyseMap.value, field: "data", label: "Dados da Análise" },
      evaluationMap.value,
      employeeMap.value,
      resultMap.value,
    ],
  },
  {
    table: "evaluation",
    label: "Avaliação",
    list: [
      {
        ...evaluationMap.value,
        field: "data",
        label: "Dados da Avaliação",
      },
    ],
  },
  {
    table: "equipment",
    label: "Equipamentos",
    list: [
      {
        ...equipmentMap.value,
        field: "data",
        label: "Dados do Equipamento",
      },
    ],
  },
  {
    table: "results",
    label: "Resultados",
    list: [
      { ...resultMap.value, field: "data", label: "Dados do Resultado" },
      analyseMap.value,
      answerMap.value,
      employeeMap.value,
      equipmentMap.value,
      evaluationMap.value,
      methodMap.value,
      sampleMap.value,
    ],
  },
  {
    table: "employee",
    label: "Funcionários",
    list: [
      {
        ...employeeMap.value,
        field: "data",
        label: "Dados do Funcionário",
      },
    ],
  },
]);

const optionsFonts = computed(() => [
  { option: "Arial", value: "Arial" },
  { option: "Calibri", value: "Calibri" },
  { option: "Courier", value: "Courier" },
  { option: "Georgia", value: "Georgia" },
  { option: "Open Sans", value: "Open Sans" },
  { option: "Sans Serif", value: "sans-serif" },
  { option: "Times New Roman", value: "Times New Roman" },
  { option: "Verdana", value: "Verdana" },
]);

const optionsFontSize = computed(() => [
  { option: "10px", value: "10px" },
  { option: "11px", value: "11px" },
  { option: "12px", value: "12px" },
  { option: "13px", value: "13px" },
  { option: "14px", value: "14px" },
  { option: "15px", value: "15px" },
  { option: "16px", value: "16px" },
  { option: "17px", value: "17px" },
  { option: "18px", value: "18px" },
  { option: "20px", value: "20px" },
  { option: "22px", value: "22px" },
  { option: "24px", value: "24px" },
  { option: "26px", value: "26px" },
  { option: "28px", value: "28px" },
  { option: "30px", value: "30px" },
]);

const tabs = computed(() => [
  { key: "query", label: "Conteúdo" },
  { key: "cols", label: "Colunas" },
  { key: "rows", label: "Linhas" },
  { key: "style", label: "Estilo" },
]);

const disableFilterAdd = computed(
  () =>
    (!filter.value.table && !filter.value.field && !filter.value.value) ||
    (!filter.value.table && !filter.value.field),
);

const disableFilterClear = computed(
  () => !filter.value.table && !filter.value.field && !filter.value.value,
);

function initialize(block: ReportBlockType) {
  internalBlock.value = {
    ...block,
    style: {
      ...DEFAULT_STYLE,
      ...block.style,
    },
  };

  internalStyle.value = {
    ...DEFAULT_STYLE,
    ...block.style,
  };

  columns.value = (internalBlock.value.content.columns || []).filter(
    (col: any) => !!col.visible,
  );
}

function getTitle(value: any) {
  const title = titles.value[value?.toLowerCase() as never] ?? value;

  if (typeof title === "string") {
    if (String(title).length > 40) {
      return `${String(title).substring(0, 40)}...`;
    }

    return title;
  }

  return title;
}

function onUpdate(key: keyof typeof internalBlock.value, value: any) {
  internalBlock.value = {
    ...internalBlock.value,
    [key]: value,
  };

  emit("block:update", {
    block_id: internalBlock.value.block_id,
    payload: { [key]: value },
  });
}

function changeSwitch(
  key: keyof typeof internalStyle.value,
  checked: boolean,
  value: string,
) {
  const defaultValues = {
    "font-weight": "normal",
    "font-style": "normal",
    "text-align": "left",
  };

  if (!checked) {
    internalStyle.value[key] = defaultValues[key as never];
  } else {
    internalStyle.value[key] = value;
  }

  onUpdate("style", internalStyle.value);
}

function normalizeHex(e: any) {
  let v = e.target.value.toLowerCase();

  if (!v.startsWith("#")) v = "#" + v;

  v = v.replace(/[^#0-9a-f]/g, "");

  if (v.length > 7) v = v.slice(0, 7);

  e.target.value = v;
  internalStyle.value.background = v;
}

function colQueryTable() {
  return tableMap.value.find(
    (t) => t.table === internalBlock.value.content.table,
  );
}

function colQueryGroup(col: any) {
  const table = colQueryTable();
  if (!table) return null;
  return table.list.find((g) => g.field === col.query.group);
}

function onChangeTable() {
  const payload = {
    ...internalBlock.value.content,
    table: internalBlock.value.content.table,
    columns:
      internalBlock.value.content.columns?.map((header: any) => ({
        ...header,
        query: {
          ...header.query,
          table: null,
          group: null,
          field: null,
          custom: null,
        },
      })) ?? [],
    rows: [],
  };

  onUpdate("content", payload);
}

function onQueryChange(col: any) {
  if (!col.query.group) {
    col.query.field = null;
    col.query.custom = null;
  }

  onChangeFilter();
}

function onInputCol() {
  onUpdate("content", internalBlock.value.content);
}

function addCol() {
  const newCol = {
    id: bsonId(),
    label: `Coluna ${internalBlock.value.content.columns.length + 1}`,
    visible: true,
    query: {
      group: null,
      field: null,
      custom: null,
    },
  };

  const payload = {
    ...internalBlock.value.content,
    columns: [...internalBlock.value.content.columns, newCol],
    rows: (internalBlock.value.content.rows ?? []).map((row: any) => ({
      ...row,
      items: [
        ...row.items,
        {
          id: bsonId(),
          col: newCol.id,
          visible: true,
          value: "",
        },
      ],
    })),
  };

  onUpdate("content", payload);
}

function colReorder() {
  const columns = internalBlock.value.content.columns;

  const rows = internalBlock.value.content.rows ?? [];
  for (const row of rows) {
    const items = [];
    for (const col of columns) {
      const item = row.items.find((i: any) => i.col === col.id);

      if (item) {
        items.push(item);
      }
    }
    row.items = items;
  }

  onUpdate("content", internalBlock.value.content);
}

function colMoveUp(index: number) {
  const columns = internalBlock.value.content.columns;
  const col = columns[index];

  if (!col) return;

  columns.splice(index, 1);
  columns.splice(index - 1, 0, col);

  const rows = internalBlock.value.content.rows ?? [];
  for (const row of rows) {
    const items = [];
    for (const col of columns) {
      const item = row.items.find((i: any) => i.col === col.id);

      if (item) {
        items.push(item);
      }
    }

    row.items = items;
  }

  onUpdate("content", internalBlock.value.content);
}

function colMoveDown(index: number) {
  const columns = internalBlock.value.content.columns;
  const col = columns[index];

  if (!col) return;

  columns.splice(index, 1);
  columns.splice(index + 1, 0, col);

  const rows = internalBlock.value.content.rows ?? [];
  for (const row of rows) {
    const items = [];
    for (const col of columns) {
      const item = row.items.find((i: any) => i.col === col.id);
      if (item) {
        items.push(item);
      }
    }
    row.items = items;
  }

  onUpdate("content", internalBlock.value.content);
}

function colRemove(index: number) {
  const columns = internalBlock.value.content.columns;
  const colToRemove = columns[index];

  if (!colToRemove) return;

  columns.splice(index, 1);

  const rows = internalBlock.value.content.rows ?? [];
  for (const row of rows) {
    row.items = row.items.filter((item: any) => item.col !== colToRemove.id);
  }

  onUpdate("content", internalBlock.value.content);
}

function checkIsImage(data: any) {
  const table = tableMap.value.find(
    (t) => t.table === internalBlock.value.content.table,
  );

  if (!table) return false;

  const group = table.list?.find(
    (g: any) => g.field === data.query.group,
  ) as any;

  if (!group) return false;
  if (group.is_image) return true;

  const field = group.list?.find(
    (f: any) => f.field === data.query.field,
  ) as any;

  if (!field) return false;
  if (field.is_image) return true;

  return false;
}

function onChangeFilter() {
  const data = get(dataMap.value, internalBlock.value.content.table, null);
  const filters: FilterType[] = internalBlock.value.content.filters || [];

  const dataList = toArray(data);

  const list = dataList.filter((item: any) => {
    if (!item) return false;
    if (filters.length === 0) return true;

    return filters.every((filterItem) => {
      const value = filterItem.custom ?? filterItem.value;

      if (isEmptyValue(value)) return true;

      if (filterItem.field?.includes("custom")) {
        const direct = toArray(item?.[filterItem.field!]);
        const nested = toArray(
          get(item, `${filterItem.table}.${filterItem.field}`, null),
        );
        const all = [...direct, ...nested];

        if (all.length === 0) return false;

        return all.some(
          (entry: any) =>
            looseEqual(entry?.label, value) ||
            looseEqual(entry?.name, value) ||
            looseEqual(entry?.value, value),
        );
      }

      const raw = get(item, filterItem.table!, null);
      const tableArray = toArray(raw);

      if (tableArray.length === 0) return false;

      return tableArray.some((t: any) =>
        looseEqual(t?.[filterItem.field!], value),
      );
    });
  });

  const payload = {
    ...internalBlock.value.content,
    rows: Array.from(list).map((data: any) => ({
      id: bsonId(),
      visible: true,
      items: [
        ...(internalBlock.value.content.columns ?? []).map((item: any) => {
          if (!list || item.query.group === null || item.query.field === null) {
            return {
              col: item.id,
              id: bsonId(),
              is_image: false,
              value: "",
              visible: true,
            };
          }

          const isImage = checkIsImage(item);

          if (item.query.field?.includes("custom")) {
            const direct = toArray(data?.[item.query.field!]);
            const nested = toArray(
              get(data, `${item.query.group}.${item.query.field}`, null),
            );
            const arr = [...direct, ...nested];

            const found = arr.find((f: any) =>
              looseEqual(f?.label, item.query?.custom),
            );

            return {
              col: item.id,
              id: bsonId(),
              is_image: isImage,
              value: resolveCellValue(found?.value, isImage),
              visible: true,
            };
          }

          const group = get(data, item.query.group, null);

          if (Array.isArray(group)) {
            return {
              col: item.id,
              id: bsonId(),
              is_image: isImage,
              value: group
                .map((g: any) =>
                  resolveCellValue(get(g, item.query.field, ""), isImage),
                )
                .filter((v) => v !== "")
                .join(", "),
              visible: true,
            };
          }

          return {
            col: item.id,
            id: bsonId(),
            is_image: isImage,
            value: resolveCellValue(get(group, item.query.field, ""), isImage),
            visible: true,
          };
        }),
      ],
    })),
  };

  onUpdate("content", payload);
}

function filterQueryList() {
  const list = get(dataMap.value, props.block.content.table, [])
    ?.flatMap((item: any) => toArray(get(item, filter.value.table!, [])))
    ?.map((item: any) => {
      const value = get(item, filter.value.field!, "");
      const label = getTitle(value);

      return { label, value };
    })
    ?.filter((item: any) => item.value)
    ?.reduce((acc: any[], item: any) => {
      if (!acc.find((i: any) => i.value === item.value)) {
        acc.push(item);
      }
      return acc;
    }, []);

  filterOptions.value = [...list, { label: "Personalizado", value: "custom" }];
}

function filterClear() {
  filter.value = {
    custom: null,
    field: null,
    table: null,
    value: null,
  };

  filterOptions.value = [];
}

function filterAdd() {
  if (!internalBlock.value.content.filters) {
    internalBlock.value.content.filters = [];
  }

  internalBlock.value.content.filters.push(filter.value);

  onChangeFilter();

  filterClear();
}

function filterRemove(index: any) {
  internalBlock.value.content.filters.splice(index, 1);

  onChangeFilter();
}

watch(
  () => props.block,
  (newValue) => {
    if (newValue) {
      initialize(newValue);
    }
  },
  { deep: true },
);

onMounted(() => {
  if (props.block) {
    initialize(props.block);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.key,
          class: _normalizeClass(["tab", { active: selectedTab.value === item.key }]),
          onClick: ($event: any) => (selectedTab.value = item.key)
        }, _toDisplayString(item.label), 11, _hoisted_3))
      }), 128))
    ]),
    (selectedTab.value === 'query')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[25] || (_cache[25] = _createElementVNode("label", null, "Nome da Tabela", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalBlock.value.content.title) = $event)),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (onInputCol()))
              }, null, 544), [
                [_vModelText, internalBlock.value.content.title]
              ])
            ])
          ]),
          _cache[35] || (_cache[35] = _createElementVNode("div", { class: "query-title" }, "Fonte de Dados", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[27] || (_cache[27] = _createElementVNode("label", null, "Tabela", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((internalBlock.value.content.table) = $event)),
                onChange: _cache[3] || (_cache[3] = ($event: any) => (onChangeTable()))
              }, [
                _cache[26] || (_cache[26] = _createElementVNode("option", { value: null }, "Selecione...", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableMap.value, (t) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: t.table,
                    value: t.table
                  }, _toDisplayString(t.label), 9, _hoisted_9))
                }), 128))
              ], 544), [
                [_vModelSelect, internalBlock.value.content.table]
              ])
            ])
          ]),
          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "query-title" }, "Filtros", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[29] || (_cache[29] = _createElementVNode("label", null, "Tabela", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filter.value.table) = $event)),
                disabled: !internalBlock.value.content.table,
                onChange: _cache[5] || (_cache[5] = ($event: any) => {
                filter.value.field = null;
                filter.value.value = null;
              })
              }, [
                _cache[28] || (_cache[28] = _createElementVNode("option", { value: null }, "Selecione...", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colQueryTable()?.list, (g) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: g.field,
                    value: g.field
                  }, _toDisplayString(g.label), 9, _hoisted_13))
                }), 128))
              ], 40, _hoisted_12), [
                [_vModelSelect, filter.value.table]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[31] || (_cache[31] = _createElementVNode("label", null, "Campo", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filter.value.field) = $event)),
                disabled: !filter.value.table,
                onChange: _cache[7] || (_cache[7] = ($event: any) => {
                filterQueryList();
                filter.value.value = null;
              })
              }, [
                _cache[30] || (_cache[30] = _createElementVNode("option", { value: null }, "Selecione...", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colQueryGroup({ query: { group: filter.value.table } })
                  ?.list, (f) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: f.field,
                    value: f.field
                  }, _toDisplayString(f.label), 9, _hoisted_16))
                }), 128))
              ], 40, _hoisted_15), [
                [_vModelSelect, filter.value.field]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[33] || (_cache[33] = _createElementVNode("label", null, "Valor", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filter.value.value) = $event)),
                disabled: !filter.value.field || filter.value.field?.includes('custom')
              }, [
                _cache[32] || (_cache[32] = _createElementVNode("option", { value: null }, "Selecione...", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterOptions.value, (f) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: f.value,
                    value: f.value
                  }, _toDisplayString(f.label), 9, _hoisted_19))
                }), 128))
              ], 8, _hoisted_18), [
                [_vModelSelect, filter.value.value]
              ])
            ]),
            (isCustom.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _cache[34] || (_cache[34] = _createElementVNode("label", null, " ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filter.value.custom) = $event))
                  }, null, 512), [
                    [_vModelText, filter.value.custom]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                class: "filter-btn",
                disabled: disableFilterAdd.value,
                onClick: _cache[10] || (_cache[10] = ($event: any) => (filterAdd()))
              }, " Adicionar ", 8, _hoisted_22),
              _createElementVNode("button", {
                class: "filter-btn",
                disabled: disableFilterClear.value,
                onClick: _cache[11] || (_cache[11] = ($event: any) => (filterClear()))
              }, " Limpar Filtros ", 8, _hoisted_23)
            ])
          ]),
          _cache[37] || (_cache[37] = _createElementVNode("div", { class: "query-title" }, "Filtros Adicionados", -1)),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.content.filters, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "filter-item"
                }, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("span", null, "Tabela: " + _toDisplayString(getTitle(item.table)), 1),
                    _createElementVNode("span", null, "Campo: " + _toDisplayString(getTitle(item.field)), 1),
                    (item.value?.includes('custom'))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Valor: " + _toDisplayString(item.custom || "—"), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_28, "Valor: " + _toDisplayString(getTitle(item.value) || "—"), 1))
                  ]),
                  _createElementVNode("button", {
                    class: "remove-btn",
                    onClick: ($event: any) => (filterRemove(index))
                  }, " × ", 8, _hoisted_29)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedTab.value === 'cols')
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createVNode(_unref(draggable), {
            class: "blocks-container",
            modelValue: columns.value,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((columns).value = $event)),
            "item-key": "id",
            handle: ".drag-handle",
            onEnd: colReorder
          }, {
            item: _withCtx(({ element: col, index: colIndex }) => [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _cache[38] || (_cache[38] = _createElementVNode("div", { class: "drag-handle" }, "⠿", -1)),
                  _createElementVNode("button", {
                    class: "block-btn",
                    disabled: colIndex === 0,
                    onClick: _withModifiers(($event: any) => (colMoveUp(colIndex)), ["stop"])
                  }, " ↑ ", 8, _hoisted_33),
                  _createElementVNode("button", {
                    class: "block-btn",
                    disabled: colIndex === columns.value.length - 1,
                    onClick: _withModifiers(($event: any) => (colMoveDown(colIndex)), ["stop"])
                  }, " ↓ ", 8, _hoisted_34),
                  _createElementVNode("button", {
                    class: "block-btn danger",
                    title: "Remover",
                    onClick: _withModifiers(($event: any) => (colRemove(colIndex)), ["stop"])
                  }, [
                    _createVNode(_unref(svgIcon), {
                      icon: "trash",
                      size: "1rem"
                    })
                  ], 8, _hoisted_35)
                ]),
                (colQueryTable())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _cache[44] || (_cache[44] = _createElementVNode("div", { class: "query-title" }, "Fonte de Dados", -1)),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _cache[40] || (_cache[40] = _createElementVNode("label", null, "Grupo", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": ($event: any) => ((col.query.group) = $event),
                            onChange: ($event: any) => (onQueryChange(col))
                          }, [
                            _cache[39] || (_cache[39] = _createElementVNode("option", { value: null }, "Selecione...", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colQueryTable()?.list, (g) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: g.field,
                                value: g.field
                              }, _toDisplayString(g.label), 9, _hoisted_40))
                            }), 128))
                          ], 40, _hoisted_39), [
                            [_vModelSelect, col.query.group]
                          ])
                        ]),
                        (colQueryGroup(col))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _cache[42] || (_cache[42] = _createElementVNode("label", null, "Campo", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": ($event: any) => ((col.query.field) = $event),
                                onChange: ($event: any) => {
                          onQueryChange(col);
                          col.query.custom = null;
                        }
                              }, [
                                _cache[41] || (_cache[41] = _createElementVNode("option", { value: null }, "Selecione...", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colQueryGroup(col)?.list, (f) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: f.field,
                                    value: f.field
                                  }, _toDisplayString(f.label), 9, _hoisted_43))
                                }), 128))
                              ], 40, _hoisted_42), [
                                [_vModelSelect, col.query.field]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (col.query.field?.includes('custom'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                              _cache[43] || (_cache[43] = _createElementVNode("label", null, "Nome", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((col.query.custom) = $event),
                                onInput: ($event: any) => (onQueryChange(col))
                              }, null, 40, _hoisted_45), [
                                [_vModelText, col.query.custom]
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _cache[45] || (_cache[45] = _createElementVNode("label", null, "Nome", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((col.label) = $event),
                      onInput: _cache[12] || (_cache[12] = ($event: any) => (onInputCol()))
                    }, null, 40, _hoisted_48), [
                      [_vModelText, col.label]
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("button", {
              class: "btn-add-col",
              onClick: addCol
            }, [
              _createVNode(_unref(svgIcon), {
                icon: "add",
                size: "1rem"
              }),
              _cache[46] || (_cache[46] = _createTextVNode(" Adicionar Coluna ", -1))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedTab.value === 'style')
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _cache[47] || (_cache[47] = _createElementVNode("label", null, "Estilo de Fonte", -1)),
            _createVNode(_unref(baseSelect), {
              modelValue: internalStyle.value['font-family'],
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((internalStyle.value['font-family']) = $event)),
              value: internalStyle.value['font-family'],
              height: "32px",
              "is-empty": false,
              options: optionsFonts.value,
              onChange: _cache[15] || (_cache[15] = ($event: any) => (onUpdate('style', internalStyle.value)))
            }, null, 8, ["modelValue", "value", "options"])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _cache[48] || (_cache[48] = _createElementVNode("label", null, "Tamanho da Fonte", -1)),
            _createVNode(_unref(baseSelect), {
              modelValue: internalStyle.value['font-size'],
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((internalStyle.value['font-size']) = $event)),
              value: internalStyle.value['font-size'],
              height: "32px",
              "is-empty": false,
              options: optionsFontSize.value,
              onChange: _cache[17] || (_cache[17] = ($event: any) => (onUpdate('style', internalStyle.value)))
            }, null, 8, ["modelValue", "value", "options"])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _cache[49] || (_cache[49] = _createElementVNode("label", null, "Fromatação", -1)),
            _createElementVNode("div", _hoisted_54, [
              _createVNode(_unref(baseSwitch), {
                value: internalStyle.value['font-style'] === 'italic',
                label: "Itálico",
                onChange: _cache[18] || (_cache[18] = ($event: any) => (changeSwitch('font-style', $event, 'italic')))
              }, null, 8, ["value"]),
              _createVNode(_unref(baseSwitch), {
                value: internalStyle.value['text-decoration'] === 'underline',
                label: "Sublinhado",
                onChange: _cache[19] || (_cache[19] = ($event: any) => (changeSwitch('text-decoration', $event, 'underline')))
              }, null, 8, ["value"]),
              _createVNode(_unref(baseSwitch), {
                value: internalStyle.value['text-decoration'] === 'line-through',
                label: "Tachado",
                onChange: _cache[20] || (_cache[20] = ($event: any) => (changeSwitch('text-decoration', $event, 'line-through')))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _cache[50] || (_cache[50] = _createElementVNode("label", null, "Cor da Fonte", -1)),
            _createElementVNode("div", _hoisted_56, [
              _withDirectives(_createElementVNode("input", {
                class: "color-input",
                type: "text",
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((internalStyle.value['color']) = $event)),
                maxlength: "7",
                onInput: normalizeHex,
                onChange: _cache[22] || (_cache[22] = ($event: any) => (onUpdate('style', internalStyle.value))),
                placeholder: "#000000"
              }, null, 544), [
                [_vModelText, internalStyle.value['color']]
              ]),
              _createVNode(_unref(ColorPicker), {
                pureColor: internalStyle.value['color'],
                "onUpdate:pureColor": [
                  _cache[23] || (_cache[23] = ($event: any) => ((internalStyle.value['color']) = $event)),
                  _cache[24] || (_cache[24] = ($event: any) => (onUpdate('style', internalStyle.value)))
                ],
                format: "hex"
              }, null, 8, ["pureColor"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})